export const vFocus = {
    mounted(el, binding) {
        if (binding.value === false) return;
        const input = el.querySelector('input, textarea');
        if (input) input.focus();
    }
};